/**
 * Booqable Global Configuration
 * Shared configuration for all Booqable components
 */

window.BooqableConfig = window.BooqableConfig || {
    // API Configuration
    slug: 'the-social-kitchen',
    storefrontToken: '5e6ebf3d24ab26f8c300721e9ff8485e',
    provider: 'Shopify',

    // Cart minimums (overridden at runtime by theme setting in booqable-cart-drawer.liquid)
    minCartValue: 0, 
    minCartMessageBelow: 'Add {missing} more to reach the {minimum} minimum',
    minCartMessageMet: ' You met Minimum order ',

    // Sample orders are exempt from the minimum spend. The shopper opts in via a
    // checkbox in the cart drawer; the flag is persisted so the exemption still
    // applies on the checkout page, where the same gate runs again.
    sampleOrderKey: 'bqSampleOrder',
    sampleOrderLabel: 'I confirm this order is for samples',
    minCartMessageSample: 'Sample order - no minimum spend applies',

    API_URL: "https://tsk-sheet-script-90441122ca67.herokuapp.com/api/v1",
    // API_URL: "http://localhost:3000/api/v1",

    // Shopify App Proxy base. Same-origin: the storefront calls this path on the
    // shop domain and Shopify forwards it to the app, adding an HMAC signature
    // that is what makes the customer id trustworthy.
    //
    // Must match `prefix` + `subpath` in the app's shopify.app.toml. These are
    // immutable per store once the app is installed.
    PROXY_URL: '/apps/tsk',

    // Computed API Base URL
    get apiBaseUrl() {
        return `https://${this.slug}.booqableshop.com/api/1`;
    },

    // Get API headers
    getHeaders(includeContentType = false) {
        const headers = {
            'Accept': 'application/json',
            'x-booqable-store-provider': this.provider,
            'x-booqable-storefront-token': this.storefrontToken
        };

        if (includeContentType) {
            headers['Content-Type'] = 'application/json';
        }

        return headers;
    },

    /**
     * Whether the shopper has flagged this cart as a sample order.
     */
    isSampleOrder() {
        try {
            return localStorage.getItem(this.sampleOrderKey) === 'true';
        } catch (error) {
            return false;
        }
    },

    /**
     * Set (or clear) the sample-order flag and notify listening components.
     */
    setSampleOrder(value) {
        const enabled = !!value;

        try {
            if (enabled) {
                localStorage.setItem(this.sampleOrderKey, 'true');
            } else {
                localStorage.removeItem(this.sampleOrderKey);
            }
        } catch (error) {
            console.warn('[BooqableConfig] Could not persist sample order flag:', error);
        }

        document.dispatchEvent(new CustomEvent('booqable:sample-order-changed', {
            detail: { sampleOrder: enabled }
        }));

        return enabled;
    },

    /**
     * Evaluate a cart against the minimum-spend rule.
     * Shared by the cart drawer and the checkout summary/form so the gate
     * stays identical wherever quantities can be changed.
     *
     * Returns null when the rule is inactive (no minimum set, empty cart, or
     * totals not yet loaded). Otherwise { met, subtotalCents, minCents, missingCents }.
     */
    getMinSpendStatus(cart) {
        const minPounds = parseFloat(this.minCartValue) || 0;
        if (minPounds <= 0) return null;

        const lines = cart?.lines || [];
        if (lines.length === 0) return null;

        const subtotalCents = cart?.grand_total_in_cents;
        if (subtotalCents == null) return null;

        const minCents = Math.round(minPounds * 100);
        // A sample order satisfies the rule regardless of subtotal.
        const sample = this.isSampleOrder();
        const met = sample || subtotalCents >= minCents;

        return {
            met,
            sample,
            subtotalCents,
            minCents,
            missingCents: met ? 0 : minCents - subtotalCents
        };
    }
};
